import { useMemo } from 'react'
import qs from 'qs'
import { Link } from 'react-router-dom'
import { faArrowLeft } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { SenceAPI, SENCE_LOGIN_ERROR_URL, SENCE_LOGIN_URL } from 'config'
import Button, {
  ButtonSizes,
  ButtonType,
  ButtonVariant,
} from 'design-system/button'
import { PathRoutes } from 'enum/routes'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { FormCommon } from '../FormCommon'
import { useIntegrations } from 'contexts/IntegrationsContext'

export const LoginSenceForm = () => {
  const {
    sence: { params, loading, data },
  } = useIntegrations()
  const t = useTranslationRankmi({
    prefix: 'courses.show.sence',
  })

  const to = useMemo(() => {
    const url = new URL(location.href)
    url.search = ''
    return url.toString()
  }, [])

  if (!data) return null

  const senceLoginError = `${SENCE_LOGIN_ERROR_URL}?${qs.stringify({
    to,
  })}`
  const senceLoginSuccess = `${SENCE_LOGIN_URL}?${qs.stringify({
    to,
  })}`

  return (
    <form action={SenceAPI.logIn} method="post">
      <FormCommon
        error={senceLoginError}
        success={senceLoginSuccess}
        data={data}
        params={params}
      />
      <Button
        variant={ButtonVariant.Secondary}
        size={ButtonSizes.Small}
        disabled={loading}
        component={Link}
        to={PathRoutes.MAIN}
      >
        <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
        {t('login.back')}
      </Button>
      <Button
        variant={ButtonVariant.Primary}
        size={ButtonSizes.Small}
        type={ButtonType.Submit}
        disabled={loading}
      >
        {t('login.button')}
      </Button>
    </form>
  )
}
